import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { TuiNotification } from '@taiga-ui/core';

@Component({
  selector: 'pxc-archived-notification',
  imports: [TuiNotification],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './archived-notification.component.html',
})
export class ArchivedNotificationComponent {
  private readonly translocoService = inject(TranslocoService);

  @Input() title = this.translocoService.translate('Cet élément est archivé');
  @Input() description = this.translocoService.translate(
    'Vous ne pouvez plus modifier ou ajouter de données à cet élément.',
  );
}
